import React from 'react';

const AutoEST = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', height: '100%' }}>
            <img src="https://media0.giphy.com/media/TLeLKUdIc1tvAxb7ab/giphy.gif" alt="Work in Progress" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
    );
};

export default AutoEST;
